export default __webpack_public_path__ + "static/media/Water - Coral.bec2bbda.svg";